import { useMessageWaitingRows } from './messageWaiting';
import type { UserDoc } from './users';

/**
 * The family side of the app icon badge, beside useStaffMessageWaitingCount
 * in staffWaitingOnYou.ts, and since B17 the same hook: every row Messages
 * shows as unread (lib/messagesUnreadCore.ts, which Messages marks its rows
 * with), so the badge, the home row and Messages should agree (known gaps: list caps, a linked Jr Staff's sign-in lookup still landing).
 *
 * Kate (2026-09-09, "badge with nothing inside"): the badge used to count the
 * raw bell cards, so a card left unread under a conversation she had already
 * read counted 1 while Messages, which folds that card into the conversation
 * row, showed nothing unread. Three cards in one conversation counted 3 over
 * one row. Both are the shared rule's job now.
 *
 * D4's history (rounds one to seven, docs/audits/refute-2026-09-16) is why the
 * hook still reads the class post window, the announcements and the read
 * cursors itself rather than trusting the bell cards: Mark all read on the
 * bell must never take an owed class post or announcement off the count.
 *
 * Takes her users doc as the caller already holds it, never its own
 * useUserDoc() listener: her muted list, her other sign-ins and whether her
 * Messages draws staff announcement rows (the Interns group, or a parent on
 * the Jr Staff roll) all come from it, as they do in Messages.
 */
export function useFamilyMessageWaitingCount(
  userDoc: UserDoc | null | undefined
): {
  count: number;
  loading: boolean;
  error: string | null;
} {
  const waiting = useMessageWaitingRows({
    mutedIds: userDoc?.notifPrefs?.mutedIds,
    staff: false,
    userDoc,
  });
  return { count: waiting.count, loading: waiting.loading, error: waiting.error };
}
